import { Input, Label } from "reactstrap";
import { LI, UL } from "../../../../AbstractElements";
import { getallCardTotal } from "../../../../Service/Ecommerce.service";
import { useAppSelector } from "../../../../Redux-Toolkit/Hooks";
import { Option1, Option2, Shipping, Subtotal } from "../../../../Constant";

const ShippingOptions = () => {
  const { cart } = useAppSelector((state) => state.cartData);

  return (
    <UL className="simple-list sub-total">
      <LI className="f-w-700">{Subtotal} <span className="count">$ {getallCardTotal(cart)}</span></LI>
      <LI className="shipping-class">{Shipping}
        <div className="shopping-checkout-option">
          <Label className="d-block m-1" htmlFor="chk-ani">
            <Input className="checkbox_animated" id="chk-ani" type="checkbox" />{Option1}
          </Label>
          <Label className="d-block m-1" htmlFor="chk-ani1">
            <Input className="checkbox_animated" id="chk-ani1" type="checkbox" />{Option2}
          </Label>
        </div>
      </LI>
    </UL>
  );
};

export default ShippingOptions;
